import React from 'react';
import {Column, Form, Input, Row, Select, TextArea, DefaultInput, CheckBox} from "../form";
import ajax from 'ajax';
import {ALERT, Alert, Confirm} from "../alert";

export default class ArtObject extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            depth: window.ArtObject.depth || false,
            location: window.ArtObject.locationManual || false,
            values: {
                ido:window.ArtObject.values.ido ? window.ArtObject.values.ido : 0,
                id: window.ArtObject.values.id ? window.ArtObject.values.id : 0,
                id_lang: window.ArtObject.values.id_lang || window.ArtObject.locale[0].id,
                author_id: window.ArtObject.values.author_id || -1,
                name: window.ArtObject.values.name || '',
                year: window.ArtObject.values.year || '',
                type: window.ArtObject.values.type || -1,
                description: window.ArtObject.values.description || '',
                location: window.ArtObject.values.location || '',
                dimensions: window.ArtObject.values.dimensions || ['', '', ''],
                genre: window.ArtObject.values.genre || [],
                color: window.ArtObject.values.color || [],
                image: window.ArtObject.values.image || [],
                technique: window.ArtObject.values.technique || -1,
                base: window.ArtObject.values.base || -1,
                technique_manual : window.ArtObject.values.technique_manual || false,
                base_manual : window.ArtObject.values.base_manual || false,
            },
            data: window.ArtObject.data || [],
            error: {}
        }
    }

    appendData(data) {
        let values = {...this.state.values};
        let changed = false;
        for(let i in values) {
            if(values.hasOwnProperty(i) && data.hasOwnProperty(i)) {
                if(Array.isArray(values[i]) && !Array.isArray(data[i])) {
                    data[i] = data[i].split(',');
                }
                changed = true;
                values[i] = data[i];
            }
        }
        if(changed) {
            this.setState({values: values});
        }
    }


    setValue(scope, value, callback) {
        const values = {...this.state.values};
        values[scope] = value;
        this.setState({
            values: values
        }, () => {
            if(callback) callback();
        })
    }

    removeError(name) {
        let error = {...this.state.error};
        if(error[name] !== undefined) {
            error[name] = false;
            //delete error[name];
            this.setState({error: error});
        }
    }

    render() {

        const colors = window.ArtObject.color.map((color) => {
            return <CheckBox
                key={color} id={color} class={'form__third form__color form__color_'+color}
                checked={this.state.values.color.indexOf(color) !== -1}
                onChange={(item) => {
                    const colors = this.state.values.color.slice();
                    const index = colors.indexOf(item.id);
                    if(index === -1 && colors.length < 3) {
                        colors.push(item.id);
                    } else if(index !== -1) {
                        colors.splice(index, 1)
                    }
                    this.setValue('color', colors)
                }}
            />;
        });

        const genres = this.state.data.genre ?
            this.state.data.genre.map((item) => {
                return <CheckBox
                    key={item.id} value={item.name} id={item.id}
                    checked={this.state.values.genre.indexOf(item.id) !== -1}
                    onChange={(item) => {
                        const genre = this.state.values.genre.slice();
                        const index = genre.indexOf(item.id);
                        if(index === -1 && genre.length < 3) {
                            genre.push(item.id);
                        } else if(index !== -1) {
                            genre.splice(index, 1)
                        }
                        this.setValue('genre', genre)
                    }}
                />;
            }) :
            null;

        const Genre = genres ?
            <Row tag="span" title={window.ArtObject.translates.genre} error={this.state.error.genre} onFocus={() => this.removeError('genre')}>
                {genres}
            </Row> : null;

        const Technique = this.state.data.technique ?
            <Select
                error={this.state.error.technique}
                onFocus={() => this.removeError('technique')}
                title={window.ArtObject.translates.technique}
                value={this.state.values.technique}
                data={this.state.data.technique}
                fieldValue="name"
                onClick={(item) => {
                    this.setValue('technique', item.id, () => {
                        this.setValue('technique_manual', item.is_manual && item.is_manual !== '0' ? (this.state.values.technique_manual || true) : false);
                    })
                }}/>
            : null;

         const TechniqueManual = this.state.values.technique_manual ?
             <Input
                 onFocus={() => this.removeError('technique_manual')}
                title={window.ArtObject.translates.technique_other}
                value={this.state.values.technique_manual === true ? '' : this.state.values.technique_manual}
                placeholder=" "
                onChange={(e) => {
                    const val = e.target.value || true;
                    this.setValue('technique_manual', val)

                }}
             /> : null;


        const Base = this.state.data.base ?
            <Select
                onFocus={() => this.removeError('base')}
                error={this.state.error.base}
                title={window.ArtObject.translates.base}
                value={this.state.values.base}
                data={this.state.data.base}
                fieldValue="name"
                onClick={(item) => {
                    this.setValue('base', item.id, () => {
                        this.setValue('base_manual', item.is_manual && item.is_manual !== '0' ? (this.state.values.base_manual || true) : false);
                    })
                }}/>
            : null;

        const BaseManual = this.state.values.base_manual ?
            <Input
                onFocus={() => this.removeError('base_manual')}
                title={window.ArtObject.translates.base_other}
                value={this.state.values.base_manual === true ? '' : this.state.values.base_manual}
                placeholder=" "
                onChange={(e) => {
                    const val = e.target.value || true;
                    this.setValue('base_manual', val)

                }}
            /> : null;


            const Images = this.state.values.image.length ? this.state.values.image.map((src, index) => {
                return <div key={index} className="image-manager__item" onContextMenu={(e) => {
                    e.preventDefault();
                    if(Confirm(window.ArtObject.translates.photo_delete)) {
                        const img = this.state.values.image.slice();
                        img.splice(index, 1);
                        this.setValue('image', img);
                    }
                }}><img src={src}/></div>;
            }) : null;

            const LocationManual = this.state.location ?
                <Input onFocus={() => this.removeError('location')} title={window.ArtObject.translates.location_other} placeholder=" " value={this.state.values.location} onChange={(e) => {
                    this.setValue('location', e.target.value);
                }}/> :
                <input type="hidden" value={this.state.values.location}/>;

            const LangSwitcher = window.ArtObject.locale.map((item) => {
                const className = item.id === this.state.values.id_lang ?
                    'lang-switcher__item lang-switcher__item_active':
                    'lang-switcher__item';
                return <button key={item.id} className={className} type="button"
                               onClick={() => {
                                   if(this.state.values.id_lang !== item.id) {
                                       ajax.post(window.ArtObject.snapUrl+'?lang='+item.id, this.state.values, (response) => {
                                           if(!response) response = {};
                                           response.id_lang = item.id;
                                           this.appendData(response);
                                       });

                                   }
                               }}
                >{item.value.toUpperCase()}</button>;
            });

            const IDO = this.state.values.ido ? <Input editable={false} readOnly={true} title="IDO" value={this.state.values.ido}/> : null;


            const FormSubmit = this.state.values.id ?
                <div className="form__row form__row_submit">
                    <div>
                        <div>
                            <a href={window.ArtObject.newUrl} className="form__submit form__submit_active">Новый арт-объект</a>
                        </div>
                        <div>
                            <button type="button" className="form__submit form__submit_active" onClick={() => {
                                ajax.post(window.ArtObject.saveUrl, this.state.values, (response) => {
                                    if(typeof response === 'object') {
                                        this.setState({error: response});
                                    } else {
                                        window.location.href = window.ArtObject.editUrl + '?id=' + encodeURIComponent(response);
                                    }
                                });
                            }}>Изменить</button>
                        </div>
                    </div>
                    <div>
                        <div>
                            <a href={window.ArtObject.listUrl} className="form__submit form__submit_active">Перейти к управлению</a>
                        </div>
                        <div>
                            <button type="button" className="form__submit" >Добавить</button>
                        </div>
                    </div>
                </div>
                :
                <div className="form__row form__row_submit">
                    <div>
                        <div>
                            <a className="form__submit">Новый арт-объект</a>
                        </div>
                        <div>
                            <button type="button" className="form__submit">Изменить</button>
                        </div>
                    </div>
                    <div>
                        <div>
                            <a className="form__submit">Перейти к управлению</a>
                        </div>
                        <div>
                            <button type="button" className="form__submit form__submit_active" onClick={() => {
                                ajax.post(window.ArtObject.saveUrl, this.state.values, (response) => {
                                    if(typeof response === 'object') {
                                        this.setState({error: response});
                                    } else {
                                        window.location.href = window.ArtObject.listUrl;
                                    }
                                });
                            }}>Добавить</button>
                        </div>
                    </div>
                </div>;


        return [
            <h1 key="header">{window.ArtObject.translates.title+ ' '}
                <span className="lang-switcher">
                    {LangSwitcher}
                </span>
            </h1>,
            <Form key="form">
                {IDO}
                <Column>
                    <Select
                        error={this.state.error.author_id}
                        onFocus={() => this.removeError('author_id')}
                        title={window.ArtObject.translates.author}
                        data={window.ArtObject.author}
                        value={this.state.values.author_id}
                        onClick={(item) => this.setValue('author_id', item.id)}
                    />
                    <TextArea
                        onFocus={() => this.removeError('name')}
                        error={this.state.error.name}
                        title={window.ArtObject.translates.name}
                        value={this.state.values.name}
                        onChange={(e) => this.setValue('name', e.target.value)}
                    />
                    <Input

                        error={this.state.error.year}
                        title={window.ArtObject.translates.year}
                        onFocus={() => this.removeError('year')}
                        value={this.state.values.year}
                        onChange={(e) => {
                            if(e.target.value === '' || /^\d{1,4}$/.test(e.target.value)){
                                this.setValue('year', e.target.value);
                            }
                        }}
                    />
                    <Select
                        onFocus={() => this.removeError('location')}
                        error={this.state.error.location}
                        title={window.ArtObject.translates.location}
                        value={this.state.values.location}
                        fieldId="value"
                        data={window.ArtObject.location}
                        onClick={item => {
                            this.setState({location: !item.id}, () => {
                                this.setValue('location', item.id ? item.value : '')
                            });
                        }}
                    />
                    {LocationManual}
                    <Select
                        onFocus={() => this.removeError('type')}
                        error={this.state.error.type}
                        title={window.ArtObject.translates.type}
                        value={this.state.values.type}
                        data={window.ArtObject.type}
                        onClick={item => {

                            ajax.post(window.ArtObject.typeUrl, {type: item.id}, (response) => {
                                const values = {...this.state.values};
                                values.genre = [];
                                values.technique = -1;
                                values.base = -1;
                                values.technique_manual = false;
                                values.base_manual = false;
                                this.setState({
                                    data: response,
                                    values: values
                                });

                            });

                            this.setValue('type', item.id, () => {

                                this.setState({
                                    depth: item.depth
                                }, () => {
                                    if(!item.depth) {
                                        const dim = this.state.values.dimensions;
                                        dim[2] = '';
                                        this.setValue('dimensions', dim);
                                    }
                                });
                            });
                        }}
                    />
                    {Genre}
                    {Technique}
                    {TechniqueManual}
                    {Base}
                    {BaseManual}
                </Column>
                <Column>
                    <Row title={window.ArtObject.translates.dimension} error={this.state.error.location}>
                        <DefaultInput
                            placeholder={window.ArtObject.translates.width} class="form__third" value={this.state.values.dimensions[0]}
                            onChange={(e) => {
                                if(/^\d*$/.test(e.target.value)) {
                                   const dim = this.state.values.dimensions.slice();
                                   dim[0] = e.target.value;
                                   this.setValue('dimensions', dim);
                                }
                            }}
                        />
                        <span className="form__separator"/>
                        <DefaultInput
                            placeholder={window.ArtObject.translates.height} class="form__third" value={this.state.values.dimensions[1]}
                            onChange={(e) => {
                                if(/^\d*$/.test(e.target.value)) {
                                    const dim = this.state.values.dimensions.slice();
                                    dim[1] = e.target.value;
                                    this.setValue('dimensions', dim);
                                }
                            }}
                        />
                        <span className="form__separator"/>
                        <DefaultInput
                            placeholder={window.ArtObject.translates.depth} class="form__third"
                            readOnly={!this.state.depth} editable={this.state.depth}
                            value={this.state.values.dimensions[2]}
                            onChange={(e) => {
                                if(/^\d*$/.test(e.target.value)) {
                                    const dim = this.state.values.dimensions.slice();
                                    dim[2] = e.target.value;
                                    this.setValue('dimensions', dim);
                                }
                            }}
                        />
                    </Row>
                    <Row tag="span" class="form__row_color" title={window.ArtObject.translates.color} error={this.state.error.location}>
                        {colors}
                    </Row>
                    <TextArea
                        onFocus={() => this.removeError('description')}
                        error={this.state.error.description}
                        title={window.ArtObject.translates.description_title}
                        placeholder={window.ArtObject.translates.description}
                        rows={6}
                        value={this.state.values.description}
                        onChange={e => this.setValue('description', e.target.value)}/>
                    <div className="form__row">
                        <span className="form__label" dangerouslySetInnerHTML={{__html: window.ArtObject.translates.photo_title}}/>
                        <div className="image-manager">
                            <div className="image-manager__list">
                                {Images}
                            </div>
                            <div className="image-manager__control form__input">
                                <span className="image-manager__file" dangerouslySetInnerHTML={{__html: window.ArtObject.translates.photo}}/>
                                <button className="image-manager__button" onClick={() => this.file.click()} dangerouslySetInnerHTML={{__html: window.ArtObject.translates.upload}}/>
                                <input ref={el => this.file = el} type="file" multiple={true} onChange={() => {
                                    const img = this.state.values.image.slice();
                                    const formData = new FormData();

                                    for(let i=0; i < this.file.files.length && i < 3 - img.length ; i++) {
                                        formData.append(i.toString(), this.file.files[i]);
                                    }

                                    $.ajax({
                                        url: window.ArtObject.imageUrl,
                                        type: 'POST',
                                        contentType: false,
                                        processData: false,
                                        dataType: 'json',
                                        data: formData,
                                        success: (response) => {
                                            for(let i = 0; i < response.length; i++) {
                                                if(!response[i].error.length) {
                                                    img.push(response[i].src);
                                                } else {
                                                    Alert(response[i].name  + ' ' + response[i].error, ALERT.ERROR);
                                                }
                                            }
                                            this.setValue('image', img);
                                        }
                                    });

                                }}/>
                            </div>
                        </div>
                    </div>
                    {FormSubmit}
                </Column>
            </Form>
        ];
    }
    
}



// WEBPACK FOOTER //
// ./bundle/component/art-object.js